export function cropTransparentPadding(image) {
  const tempCanvas = document.createElement('canvas');
  const tempCtx = tempCanvas.getContext('2d');
  tempCanvas.width = image.naturalWidth;
  tempCanvas.height = image.naturalHeight;
  tempCtx.drawImage(image, 0, 0);

  const { width, height } = tempCanvas;
  const imageData = tempCtx.getImageData(0, 0, width, height);
  const data = imageData.data;

  let top = 0;
  let left = 0;
  let right = width - 1;
  let bottom = height - 1;

  const isRowTransparent = (y) => {
    const rowStart = y * width * 4;
    for (let x = 0; x < width; x += 1) {
      if (data[rowStart + x * 4 + 3] !== 0) return false; // alpha channel
    }
    return true;
  };

  const isColTransparent = (x, yStart, yEnd) => {
    for (let y = yStart; y <= yEnd; y += 1) {
      const idx = (y * width + x) * 4 + 3; // alpha channel
      if (data[idx] !== 0) return false;
    }
    return true;
  };

  while (top <= bottom && isRowTransparent(top)) top += 1;
  while (bottom >= top && isRowTransparent(bottom)) bottom -= 1;
  while (left <= right && isColTransparent(left, top, bottom)) left += 1;
  while (right >= left && isColTransparent(right, top, bottom)) right -= 1;

  const croppedWidth = Math.max(1, right - left + 1);
  const croppedHeight = Math.max(1, bottom - top + 1);

  const cropCanvas = document.createElement('canvas');
  const cropCtx = cropCanvas.getContext('2d');
  const targetMax = 256;
  const scale = Math.min(targetMax / croppedWidth, targetMax / croppedHeight);
  cropCanvas.width = Math.round(croppedWidth * scale);
  cropCanvas.height = Math.round(croppedHeight * scale);

  cropCtx.imageSmoothingEnabled = true;
  cropCtx.imageSmoothingQuality = 'high';
  cropCtx.drawImage(
    tempCanvas,
    left,
    top,
    croppedWidth,
    croppedHeight,
    0,
    0,
    cropCanvas.width,
    cropCanvas.height
  );

  return cropCanvas.toDataURL('image/png');
}

export function createOrUpdateIcon(rel, sizes, href, type) {
  const selector = sizes
    ? `link[rel='${rel}'][sizes='${sizes}']`
    : `link[rel='${rel}']`;
  let link = document.querySelector(selector);
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', rel);
    if (sizes) link.setAttribute('sizes', sizes);
    document.head.appendChild(link);
  }
  if (type) link.setAttribute('type', type);
  link.setAttribute('href', href);
}

export function registerFavicons(href) {
  const pngType = 'image/png';
  const sizes = ['32x32', '48x48', '64x64', '96x96', '128x128', '192x192', '256x256'];
  sizes.forEach((size) => createOrUpdateIcon('icon', size, href, pngType));
  createOrUpdateIcon('shortcut icon', '', href, pngType);
  createOrUpdateIcon('apple-touch-icon', '180x180', href, pngType);
}

export function applyCroppedFaviconFromImageUrl(imageUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const croppedDataUrl = cropTransparentPadding(img);
      registerFavicons(croppedDataUrl);
      resolve();
    };
    img.src = imageUrl;
  });
}


